export default __webpack_public_path__ + "static/sustainable-tourism.tr-be4d43831fc77d5c6276dacc47cb2d12.png";